import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  actionButtonFn: () => void;
  open: boolean;
  onOpenChange: Dispatch<SetStateAction<boolean>>;
  bodyText: string
  title?: string
};

const ConfirmRemoveAlert = (props: Props) => {

  const { actionButtonFn, open, onOpenChange, bodyText, title } = props;

  const { t } = useTranslation(["components", "common"]);

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{ title ?? t("alertdialogs.removetitle") }</AlertDialogTitle>
          <AlertDialogDescription>
            {bodyText}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>
            { t("common:buttons.cancel") }
          </AlertDialogCancel>
          <AlertDialogAction onClick={actionButtonFn}>
            { t("common:buttons.confirm") }
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ConfirmRemoveAlert;
